import { Component, model } from '@angular/core';

@Component({
  selector: 'c-button-animated',
  templateUrl: './button-animated.component.html',
  styleUrl: './button-animated.component.css',
  standalone: false,
})
export class ButtonAnimatedComponent {
  collapse = model<boolean>(false);
  toggle() {
    this.collapse.update((data) => !data);
  }
}
